import React from "react";
import { throttle } from "~/features/app/utils";
export function useRecaptchaVisibility() {
  const [element, setElement] = React.useState<HTMLDivElement | null>(null);
  function isElementInViewport(el: HTMLElement) {
    const rect = el.getBoundingClientRect();
    return rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0 && rect.left < (window.innerWidth || document.documentElement.clientWidth) && rect.right > 0;
  }
  const updateBadgeVisibility = React.useCallback(() => {
    const forms = document.querySelectorAll("form");
    const anyFormInView = Array.from(forms).some(form => isElementInViewport(form as HTMLElement));
    if (element) {
      element.style.opacity = anyFormInView ? "1" : "0";
      element.style.pointerEvents = anyFormInView ? "auto" : "none";
    }
  }, [element]);
  React.useEffect(() => {
    updateBadgeVisibility();
    const onScroll = throttle(updateBadgeVisibility);
    window.addEventListener("scroll", onScroll);
    window.addEventListener("recaptcha:visibility-update", updateBadgeVisibility);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("recaptcha:visibility-update", updateBadgeVisibility);
    };
  }, [updateBadgeVisibility]);
  React.useEffect(() => {
    let cancelled = false;
    const tryAttach = () => {
      if (cancelled) return;
      // @ts-expect-error global injected by reCAPTCHA script
      if (window.grecaptcha?.enterprise?.ready) {
        // @ts-expect-error global injected by reCAPTCHA script
        grecaptcha.enterprise.ready(() => {
          if (cancelled) return;
          const badge = document.querySelector(".grecaptcha-badge");
          setElement(badge as HTMLDivElement);
        });
      }
    };
    tryAttach();

    // The reCAPTCHA script is now loaded on demand (when a form submits).
    // Listen for the load event instead of polling indefinitely.
    window.addEventListener("recaptcha:loaded", tryAttach);
    return () => {
      cancelled = true;
      window.removeEventListener("recaptcha:loaded", tryAttach);
    };
  }, []);
  return element;
}